<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div></div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <!-- <el-button size='small' @click="" type="success" style="width:90px">搜索</el-button> -->
        <!-- <el-button size='small' @click="" type="danger" style="width:90px">重置</el-button> -->
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="roleName" label="角色名称" align="center">
        </el-table-column>

        <el-table-column prop="remark" label="备注" align="center">
        </el-table-column>

        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%" @close="close">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="角色名称" prop="roleName">
                <el-input
                  v-model="addData.roleName"
                  placeholder="请输入角色名称"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="菜单列表" prop="menuIdListStr">
                <el-input
                  placeholder="请选择菜单分类"
                  auto-complete="off"
                  v-model="addData.menuIdListStr"
                  @click.native="changeSelectTree()"
                />
                <div class="tree" v-if="isShowTrue">
                  <el-tree
                    :data="muneListData"
                    ref="muneListData"
                    show-checkbox
                    default-expand-all
                    node-key="id"
                    :props="defaultProps"
                    @check-change="handleNodeClick"
                  >
                  </el-tree>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="备注说明">
                <el-input
                  type="textarea"
                  v-model="addData.remark"
                  placeholder="请输入备注说明"
                  maxlength="255"
                  rows="5"
                  show-word-limit

                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close()">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg";
export default {
  data() {
    return {
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        roleName: "", //角色名称
        menuIdList: "", //菜单列表
        remark: "", //备注
        menuIdListStr: "", //菜单列表名称
      },
      addDataRules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        menuIdListStr: [
          { required: true, message: "请选择菜单列表", trigger: "blur" },
        ],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  created() {},
  mounted() {
    this.$Apis.getMenuNav().then((res) => {
      if (res.code == 200) {
        this.muneListData = res.data;
      }
    });
    this.onLoad();
  },
  methods: {
    handleNodeClick(current, isChecked, isChildrenChecked) {
      let ids = [];
      let strList = [];
      let nodes = this.$refs.muneListData
        .getCheckedNodes()
        .concat(this.$refs.muneListData.getHalfCheckedNodes());
      for (let item of nodes) {
        ids.push(item.id);
        strList.push(item.name);
      }
      this.checkedIds = ids;
      this.checkedStr = strList;
      this.addData.menuIdList = this.checkedIds.join(",");
      this.addData.menuIdListStr = this.checkedStr.join(",");
      this.$refs["form"].validate();
    },
    // 点击input输入框 展开tree
    changeSelectTree() {
      this.isShowTrue = true;
    },
    // 新增角色
    addCharacter() {
      this.addData.roleName = "";
      this.addData.menuIdList = "";

      this.addData.menuIdListStr = "";

      this.addData.remark = "";
      this.isShowTrue = false;

      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    close(){ 
      this.$refs["form"].resetFields();
      this.isAddModal = false;
    },
    // 修改角色
    updataCharacter(row) {
      this.isShowTrue = true;
      this.addData.menuIdList = "";
      this.addData.menuIdListStr = "";

      this.addData.roleName = row.roleName;
      this.addData.remark = row.remark;
      this.addData.id = row.id;
      // 获取角色菜单信息
      this.$Apis.permissionsMenu({ roleId: row.id }).then((res) => {
        if (res.code == 200) {
          let str = [];
          this.checkedIds = res.data.menuIdList;
          this.addData.menuIdList = res.data.menuIdList;
          this.modalTitle = "修改";

          this.$nextTick(() => {
            this.$refs.muneListData.setCheckedKeys([]); // 先清空选中
            res.data.menuIdList.forEach((i) => {
              let node = this.$refs.muneListData.getNode(i);
              this.$refs.muneListData.setChecked(node, true);
              str.push(node.label);
            });
            this.checkedStr = str;
            this.addData.menuIdListStr = str.join(",");
            str = [];
          });

          this.isAddModal = true;
        } else {
          this.$message.warning("获取角色权限失败");
        }
      });
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除该角色", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.delCharacter({ roleId: id }).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            roleName: this.addData.roleName,
            remark: this.addData.remark,
            menuIdList:reg.array(this.addData.menuIdList)?this.addData.menuIdList.join(','):this.addData.menuIdList,
          };
          if (this.modalTitle == "修改") {
            data.id = this.addData.id;
          }
          this.$Apis.addOrUpdataCharacter(data).then((res) => {
            this.btnLoading = false;
            
            if (res.code == 200) {
              close()
              this.isAddModal = false;
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
      };
      this.$Apis.getCharacterList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>